import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { JoetStoreService } from './shared/services/joet-store.service';
import { interval } from 'rxjs';
import { RealtimeService as RealtimeSignalRService } from './shared/signalR/services/real-time.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.less'
})
export class App {
  protected readonly title = signal('JOET');
  joetstoreService = inject(JoetStoreService);
  realTimeSignalRService = inject(RealtimeSignalRService);
  http = inject(HttpClient);
  ngOnInit() {
    this.joetstoreService.initializeStore();

    interval(60000).subscribe(() => {
      if(this.joetstoreService.isLoggedIn()) {
      this.joetstoreService.initializeStore();
      }
    });

    if(this.joetstoreService.isLoggedIn()) {
      
      this.realTimeSignalRService.start(
        async () => await this.joetstoreService.Token
      );
    }

      
  }
}
